import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { Input, version2 } from 'ui-components/components/input';
import {
  NotificationService,
  NOTIFICATION_TYPE_ERROR,
  NOTIFICATION_TYPE_SUCCESS,
  NOTIFICATION_DURATIONS,
} from 'ui-components/services/notification-service';

import { updateUnishippersCredentials } from './api';
import messages from './messages';
import style from './style.module.less';
import { SettingsPageTitle } from '../../components/settings-page-title/settings-page-title';
import commonStyles from '../../settings-page.module.less';

const initialCredentials = { customerNumber: '', userName: '', password: '' };

export const UnishippersSettingsPage = () => {
  const [credentials, setCredentials] = useState(initialCredentials);
  const updateCredentials = useCallback((e) => {
    const { name, value } = e.target;
    setCredentials((stateCreds) => ({
      ...stateCreds,
      [name]: value,
    }));
  }, []);
  const { customerNumber, password, userName } = credentials;

  const onSubmit = useCallback(() => {
    updateUnishippersCredentials(credentials)
      .then((response) => {
        const { status, data } = response;
        if (status === 200 && data?.success) {
          return NotificationService.showNotification({
            title: '',
            notificationType: NOTIFICATION_TYPE_SUCCESS,
            content: <FormattedMessage {...messages.unishippersSuccessMessage} />,
            duration: NOTIFICATION_DURATIONS.SHORT,
          });
        }
        NotificationService.showNotification({
          title: '',
          notificationType: NOTIFICATION_TYPE_ERROR,
          content: <FormattedMessage {...messages.unishippersFailureMessage} />,
          duration: NOTIFICATION_DURATIONS.SHORT,
        });
      })
      .catch(() => {
        NotificationService.showNotification({
          title: '',
          notificationType: NOTIFICATION_TYPE_ERROR,
          content: <FormattedMessage {...messages.unishippersFailureMessage} />,
          duration: NOTIFICATION_DURATIONS.SHORT,
        });
      });
  }, [credentials]);

  return (
    <div className={commonStyles.content}>
      <SettingsPageTitle value={messages.unishippersTitle} />
      <div className={style.description}>
        <div className={style.steps}>
          <FormattedMessage
            {...messages.step1}
            values={{
              a: (chunks) => (
                <a href='http://uone-billing.unishippers.com/uone/signup.do' rel='noreferrer' target='_blank'>
                  {chunks}
                </a>
              ),
            }}
          />
        </div>
        <div className={style.steps}>
          <FormattedMessage {...messages.step2} />
        </div>
      </div>
      <Input
        className={style.inputs}
        label={<FormattedMessage {...messages.customerNumberLabel} />}
        name='customerNumber'
        onChange={updateCredentials}
        value={customerNumber}
        version={version2}
      />
      <Input
        className={style.inputs}
        label={<FormattedMessage {...messages.passwordLabel} />}
        name='password'
        onChange={updateCredentials}
        value={password}
        version={version2}
      />
      <Input
        className={style.inputs}
        label={<FormattedMessage {...messages.userNameLabel} />}
        name='userName'
        onChange={updateCredentials}
        value={userName}
        version={version2}
      />
      <Button onClick={onSubmit} theme='primary'>
        <FormattedMessage {...messages.enableUnishippers} />
      </Button>
    </div>
  );
};
